import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { Gender } from './Enums'
/**
* Class WebUserProfileDto
*  Данные профиля пользователя<br>
*/
export class WebUserProfileDto extends ActiveModel {

/**
  * surname
  * Фамилия<br>
  */
  @ActiveField('')
  surname: string = ''


/**
  * name
  * Имя<br>
  */
  @ActiveField('')
  name: string = ''


/**
  * patronymic
  * Отчество<br>
  */
  @ActiveField('')
  patronymic: string = ''


/**
  * fullName
  * ФИО<br>
  */
  @ActiveField('')
  fullName: string = ''


  /**
  * gender
  * Пол<br>  */
  @ActiveField(undefined)
  gender: null | Gender = undefined


/**
  * dateOfBirth
  * Дата рождения<br>
  */
  @ActiveField(null)
  dateOfBirth: null | string = null
}
